import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DocumentTitle from 'react-document-title';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import SectorPicker from '../../components/Form/SectorPicker';
import store from "store2";


export default class List extends Component {

	static contextTypes = {
		store: React.PropTypes.object
	};

	constructor(props, context) {
		super(props);

		this.columnModel = [
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				width:80,
				sortable: false,
				renderer: (val, row) => {
					if (!row.count) {
						return false;
					}
					return (<div style={{color:'#2196F3', cursor:'pointer'}} onClick={() => this.props.onSelect(row.id)}>
							<i className="fa fa-plus"></i> vybrat
						</div>
					);
				}
			},
			{
				name: 'number',
				title: 'Protokol',
				field: 'number',
				width: 120,
				renderer: (val, row) => {
					return <span>{row.number}/{row.year}</span>;
				}
			},
			{
				name: 'cTitle',
				title: 'Firma',
				field: 'cTitle'
			},
			{
				name: 'date_from',
				title: 'Datum od',
				field: 'date_from',
				renderer: Renderers.Date
			},
			{
				name: 'date_to',
				title: 'Datum do',
				field: 'date_to',
				renderer: Renderers.Date
			},
			{
				name: 'type',
				title: 'Druh',
				field: 'type',
				renderer: Renderers.DbInfo.bind(DbInfo.TrainingType(context.store))
			},
			{
				name: 'users',
				title: 'Účastníků',
				sortable: false,
				field: 'count',
				align:'center',
				width: 16,
				renderer: (val) => {
					return val ? val : '';
				}
			}
		];

		const filterSchema = {
			number: { class: FilterInput },
			cTitle: { class: FilterInput },
			fulltext: { class: SearchInput },
			type: { class: Select, options: DbInfo.TrainingType(context.store) },
			date_from: { class: DateRange },
			date_to: { class: DateRange }
		};
		this.filter = new FormManager(filterSchema);
        const sessionState = store.session.get('dg-trainingpopup');
        this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'id', 'direction': 'asc'};

    }

	render() {

		return (
			<Datagrid
				ref="datagrid"
				id="trainingpopup"
				api="training.getList"
				buttons={<h5>Vyberte školení</h5>}
				filters={['fulltext']}
				filter={this.filter}
				saveState={false}
				getRowClassName={null}
				columnModel={this.columnModel}
				defaultFilter={{cTitle: this.props.firm}}
				forceFilter={true}
				defaultSort={this.defaultSort}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Training/PickerList.js